import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const EmptyStateContainer = styled(FlexColumn)`
    height: 340px;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .SWReactIcons {
        height: 96px;
        width: 125px;
    }
`;

EmptyStateContainer.displayName = "EmptyStateContainer";

export const EmptyText = styled.span`
    ${setFontVariant("input2", carbon[400])};
    max-width: 320px;
    text-align: center;
`;

EmptyText.displayName = "EmptyText";
